import { render, staticRenderFns } from "./InnerHeader.vue?vue&type=template&id=5489d0be&"
import script from "./InnerHeader.vue?vue&type=script&lang=ts&"
export * from "./InnerHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports